import * as XLSX from 'xlsx';

const getFileNameWithDate = (baseFileName, extension) => {
    const today = new Date().toISOString().slice(0, 10);
    return `${baseFileName}_${today}.${extension}`;
};

const downloadBlob = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

const getValidColumns = (columns = []) => {
    return columns.filter((column) => column?.key && column?.header);
};

const getCellValue = (row, key) => {
    const value = row?.[key];
    if (value === null || value === undefined) return '';
    return String(value);
};

const getAutoColumnWidth = (header, rows, key) => {
    const maxValueLength = rows.reduce((max, row) => {
        const currentLength = getCellValue(row, key).length;
        return currentLength > max ? currentLength : max;
    }, header.length);

    return Math.min(Math.max(maxValueLength + 2, 10), 40);
};

export const exportRowsToCsv = ({
    rows = [],
    columns = [],
    baseFileName = 'export',
    delimiter = ',',
}) => {
    const validColumns = getValidColumns(columns);
    if (!validColumns.length) return;

    const escapeCsv = (value) => `"${String(value).replace(/"/g, '""')}"`;

    const headerRow = validColumns.map((column) => escapeCsv(column.header)).join(delimiter);
    const contentRows = rows.map((row) => {
        return validColumns
            .map((column) => escapeCsv(getCellValue(row, column.key)))
            .join(delimiter);
    });

    const csvContent = `\uFEFF${[headerRow, ...contentRows].join('\n')}`;
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    downloadBlob(blob, getFileNameWithDate(baseFileName, 'csv'));
};

export const exportRowsToExcel = ({
    rows = [],
    columns = [],
    baseFileName = 'export',
    sheetName = 'Hoja1',
}) => {
    const validColumns = getValidColumns(columns);
    if (!validColumns.length) return;

    const sheetData = [
        validColumns.map((column) => column.header),
        ...rows.map((row) => validColumns.map((column) => getCellValue(row, column.key))),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    worksheet['!cols'] = validColumns.map((column) => ({
        wch: getAutoColumnWidth(column.header, rows, column.key),
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, getFileNameWithDate(baseFileName, 'xlsx'), {
        bookType: 'xlsx',
        compression: true,
    });
};
